<template>
    <v-card>
        <v-card-text>
            <div class="loader">
                <v-progress-circular
                    :size="50"
                    color="primary"
                    v-if="loading"
                    indeterminate />
            </div>
            <v-layout row wrap v-if="owner.id">
                <v-flex sm6>
                    <v-data-table hide-actions hide-headers :headers="h1" :items="i1">
                        <template #items="props">
                            <th>{{ props.item.name }}</th>
                            <td>{{ props.item.value }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'pad-lot-owner',
    props: {
        item: { type: Object }
    },
    data: () => ({
        loading: false,
        owner: {},
        h1: [{ text: 'Nom' }, { text: 'Valeur' }]
    }),
    computed: {
        ownerId() {
            return this.item.owner.id
        },
        i1() {
            return [
                { name: 'Code', value: this.owner.code },
                { name: 'Nom', value: `${this.owner.prenom} ${this.owner.particule} ${this.owner.nom}` },
                { name: 'Société', value: this.owner.company }
            ]
        }
    },
    mounted() {
        this.load()
    },
    methods: {
        load() {
            if (!this.ownerId) {
                return
            }
            this.loading = true
            return this.$api.get(`/users/${this.ownerId}`)
                .then(res => this.owner = res.data)
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style lang="stylus" scoped>
.loader
    text-align: center;
</style>
